import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import CorelifeLogo from "../Assets/CorelifeLogo.png";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

function ResponsiveAppBar(props) {
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar
      position="static"
      color="background"
      sx={{
        paddingX: 3,
        position: "fixed",
        zIndex: 2,
				boxShadow: "inset 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 0px 0px rgba(0, 0, 0, 0.12)"
      }}
    >
      <Toolbar disableGutters>
        <Box
          component="img"
          src={CorelifeLogo}
          sx={{
            height: "44px",
            paddingY: 1,
          }}
        ></Box>
        <Box
          sx={{
            flexGrow: 1,
            display: { xs: "none", md: "flex" },
            flexDirection: "row-reverse",
          }}
        >
          <Button
            variant="text"
            sx={{
              textTransform: "none",
              fontSize: 16,
              fontWeight: "500",
              px: 1,
              color: "primary.main",
							fontFamily: 'ProximaNovaSemibold'
            }}
            onClick={() => {
              props.onEditClick();
              handleCloseUserMenu();
            }}
          >
            Edit Payment Method
          </Button>

          <Button
            variant="text"
            sx={{
              textTransform: "none",
              fontSize: 16,
              fontWeight: "500",
              px: 1,
              color: "primary.main",
							fontFamily: 'ProximaNovaSemibold'
            }}
            onClick={() => {
              props.onViewClick();
              handleCloseUserMenu();
							
            }}
          >
            View Payment Method
          </Button>
        </Box>
        <Box
          sx={{
            flexGrow: 1,
            display: { xs: "flex", md: "none" },
            flexDirection: "row-reverse",
          }}
        >
          <Tooltip title="Payment Profile">
            <IconButton
              onClick={(event) => {
                anchorElUser === null
                  ? setAnchorElUser(event.currentTarget)
                  : setAnchorElUser(null);
              }}
              sx={{
                p: 1,
                border: 1,
                borderColor: "primary",
                borderRadius: "50%",
              }}
              color="primary"
              size="large"
            >
              <PersonOutlineIcon
                sx={{
                  fontSize: 24,
                }}
              />
            </IconButton>
          </Tooltip>
          <Menu
            sx={{ mt: "45px" }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            <MenuItem
              key="edit"
							sx={{
								minHeight: 36
							}}
              onClick={() => {
                props.onEditClick();
                handleCloseUserMenu();
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "primary.main",
                  fontWeight: 500,
                  fontSize: 16,
									lineHeight: 1.5,
									fontFamily: 'ProximaNovaSemibold'
                }}
              >
                Edit Payment Method
              </Typography>
            </MenuItem>
            <MenuItem
              key="view"
							sx={{
								height: 36
							}}
              onClick={() => {
                props.onViewClick();
                handleCloseUserMenu();
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  fontWeight: 500,
                  fontSize: 16,
									fontFamily: 'ProximaNovaSemibold',
									lineHeight: 1.5,
									color: "primary.main",
                }}
              >
                View Payment Method
              </Typography>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
export default ResponsiveAppBar;
